import React, { useEffect } from 'react';

export default function TidyCalEmbed() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://asset-tidycal.b-cdn.net/js/embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="mt-8 bg-white p-4 rounded-xl shadow-sm border border-gray-100">
      <div 
        className="tidycal-embed" 
        data-path="pinoygeneralinsurance/discovery-call-phone-or-video"
      ></div>
    </div>
  );
}